import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { MajakIcon } from '../../../common/components';
import { Calendar } from '../../../common/components/data-display';

@translate()
export default class CalendarPanel extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    installments: PropTypes.array.isRequired,
    firstUnpaidInstallment: PropTypes.object,
    toggleCalendar: PropTypes.func.isRequired,
  };

  render() {
    const { t, toggleCalendar, installments, firstUnpaidInstallment } = this.props;

    return (
      <div className="calendar-panel-wrapper">
        <div className="panel-header">
          <h2>{t('Kalendár splátok')}</h2>
          <MajakIcon onClick={toggleCalendar} type="zavriet" />
        </div>

        <Calendar installments={installments} firstUnpaidInstallment={firstUnpaidInstallment} />

        <div onClick={toggleCalendar} className="calendar-footer">
          <MajakIcon type="zavriet" /> <span>{t('zavrieť kalendár')}</span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/loans/components/CalendarPanel.js